import fetchServiceTypes from '../../../Core/Services/fetchServiceTypes';
import fetchCaveats from '../Services/fetchCaveats';

export default () => async (dispatch) => {
  
  await dispatch(fetchServiceTypes());
  dispatch(fetchCaveats());
  
}